import React, { useState } from 'react';
import { usersApi, leaguesApi } from '../services/api';
import logo from '../images/american_pub_poker.jpg';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await usersApi.loginAdmin(username.trim(), password);

      if (response.success && response.data?.id) {
        const roles = response.data.roles || [];

        // Fetch league information
        let league = null;
        try {
          const leaguesRes = await leaguesApi.getAll();
          const leagues = leaguesRes.data || leaguesRes.leagues || [];
          if (leagues.length > 0) {
            league = leagues[0]; // For now, use the first league
          }
        } catch (leagueErr) {
          console.warn('Could not fetch league info:', leagueErr);
        }

        const userData = {
          id: response.data.id,
          username: response.data.username,
          firstName: response.data.firstName || '',
          lastName: response.data.lastName || '',
          email: response.data.email,
          roles: roles,
          league: league,
        };

        onLogin(userData);
      } else {
        setError('Invalid username or password.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src={logo} alt="American Pub Poker" className="login-logo-img" />
          <h1>League Admin</h1>
          <p>Sign in to manage your poker league</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="login-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading || !username.trim() || !password.trim()}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p>American Pub Poker - League Management</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
